import { User } from 'oidc-client-ts';
import { ConfigSetting } from '@parcel2go/npm-p2g-app';
import dayjs from 'dayjs';
import { MUTINY } from './constants';

export function fetchWithTenant(
  tenant: string,
  settings: { [key: string]: string },
  url: string,
  options: RequestInit = {}
) {
  const headers = {
    ...{ ...(options.headers || {}) },
    'x-tenant': tenant.split('.')[0],
    'x-hostcountry': settings[ConfigSetting.HOST_COUNTRY]
  };
  options.headers = headers;
  options.credentials = 'include';
  return fetch(url, options);
}

export function fetchWithTenantAnalytics(
  tenant: string,
  settings: { [key: string]: string },
  session: string,
  url: string,
  options: RequestInit = {}
) {
  const headers = { ...(options.headers || {}), 'x-session': session };
  options.headers = headers;
  return fetchWithTenant(tenant, settings, url, options);
}

export function authenticatedFetchWithTenantAnalytics(
  user: User | null | undefined,
  tenant: string,
  settings: { [key: string]: string },
  session: string,
  url: string,
  options: RequestInit = {}
) {
  if (user?.access_token && user?.expires_at && dayjs.unix(user.expires_at) > dayjs()) {
    const headers = { ...(options.headers || {}), Authorization: `Bearer ${user.access_token}`, 'x-mutiny': MUTINY };
    options.headers = headers;
  }
  return fetchWithTenantAnalytics(tenant, settings, session, url, options);
}

export function fetchWithAnalytics(session: string, url: string, options: RequestInit = {}) {
  const headers = { ...(options.headers || {}), 'x-session': session };
  options.headers = headers;
  return fetch(url, options);
}
